<si-select
  class="form-control pe-auto w-100"
  hasFilter
  [attr.aria-label]="'BROUTER_MAP.SEARCH.LABEL' | translate"
  [placeholder]="'BROUTER_MAP.SEARCH.PLACEHOLDER' | translate"
  [optionSource]="placeSource"
  [ngModel]="selectedPlaceId()"
  (ngModelChange)="onPlaceChange($event)"
/>
